import { useEffect } from "react"

import Style from "./stye"

import Search from "widget/Search"
import Pagenation from "widget/Pagenation"

import useGetMyEventList from "entity/event/useGetMyEventList"
import useGetEventDetail from "entity/event/useGetEventDetail"

import DefaultModal from "shared/ui/DefaultModal"
import DefaultButton from "shared/ui/DefaultButton"
import TStyle from "shared/style/tableStyle"
import timestampCalculator from "shared/lib/timestampCalculator"
import { convertEventTypeAsName } from "shared/constant/lookup/eventType"

const EventModalManager = ({ closeEvent, setEventData }) => {

    const [eventList] = useGetMyEventList()
    const [eventDetail, getEventDetail] = useGetEventDetail(false)

    const sizeList = ["short", "expand", "medium", "long", "medium"]
    const tableHeadList = ["IDX", "이름", "대회 종류", "대회 시간", ""]

    const selectEventEvent = (data) => {
        getEventDetail(data?.idx)
    }

    useEffect(() => {
        if (eventDetail) {
            setEventData(eventDetail?.data)
            closeEvent()
        }
    }, [eventDetail])

    return (
        <DefaultModal title={"대회 검색"} closeEvent={closeEvent}>
            <Style.Wrapper>
                <Search placeholder="대회 이름에 포함되는 글자로 검색" />

                <TStyle.TableDiv>
                    <TStyle.TableRow $title>
                        {tableHeadList.map((elem, index) =>
                            <TStyle.Data $title $size={sizeList[index]}>{elem}</TStyle.Data>
                        )}
                    </TStyle.TableRow>
                    {eventList?.data?.event_list?.map((elem, index) =>
                        <TStyle.TableRow $odd={index % 2 === 1}>
                            <TStyle.Data $size={sizeList[0]}>{elem?.idx}</TStyle.Data>
                            <TStyle.Data $size={sizeList[1]}>{elem?.name}</TStyle.Data>
                            <TStyle.Data $size={sizeList[2]}>{convertEventTypeAsName[elem?.event_type_flag]}</TStyle.Data>
                            <TStyle.Data $size={sizeList[3]}>{timestampCalculator(elem?.date)}</TStyle.Data>
                            <TStyle.Data $size={sizeList[4]}>
                                <DefaultButton small fitWidth clickEvent={() => selectEventEvent(elem)}>선택하기</DefaultButton>
                            </TStyle.Data>
                        </TStyle.TableRow>
                    )}
                </TStyle.TableDiv>

                <Pagenation maxPage={1} />
            </Style.Wrapper>
        </DefaultModal>
    )
}

export default EventModalManager